"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_firebase_1 = require("react-redux-firebase");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Modal_1 = __importDefault(require("shared/components/Modal/Modal"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var hooks_1 = require("./hooks");
var ConfirmPurgeModal = function (_a) {
    var close = _a.close;
    var _b = __read((0, backend_1.useCall)('serviceStats-deleteNotSaasSpend'), 2), purgeNotSaasSpend = _b[0], isPurgingNotSaasSpend = _b[1];
    var companiesWithNonSaas = (0, hooks_1.useGetCompaniesWithNoSaas)();
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: true, onClose: close, label: "Confirm-service-stats-purge" }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, __assign({ id: "customized-dialog-title" }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Confirm Service Stats Purge" })) })), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mb: 2 }, { children: "WARNING! The following companies containing expenditure from these services will be purged." })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ component: "ul", mb: 2 }, { children: (!(0, react_redux_firebase_1.isLoaded)(companiesWithNonSaas) && 'Loading, Please wait')
                            || ((0, react_redux_firebase_1.isEmpty)(companiesWithNonSaas) && (0, jsx_runtime_1.jsx)("li", { children: "No companies found with services tagged as `isNotSaas`." }))
                            || (companiesWithNonSaas === null || companiesWithNonSaas === void 0 ? void 0 : companiesWithNonSaas.map(function (c) { return (0, jsx_runtime_1.jsxs)("li", { children: [c.companyName, " - ", c.nonSaasServiceNames.join(', ')] }, c.id); })) }))] }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, __assign({ px: 5, py: 3 }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "flex-end", gap: 3 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "neutral", onClick: close, size: "large" }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ disabled: isPurgingNotSaasSpend || (0, react_redux_firebase_1.isEmpty)(companiesWithNonSaas), onClick: function () { return purgeNotSaasSpend()().then(function () { return close(); }); }, size: "large" }, { children: "Yes I am sure" }))] })) }))] })));
};
exports.default = ConfirmPurgeModal;
